<template lang="html">
  <div class="">
    <div class="callus-wrapper" :class="{ 'active': showPhoneForm  }">
      <transition name="fade" mode="out-in">
          <div class="callus-popup" v-if="$store.state.global.showPhoneForm">
            <button class="btn-x" @click="$store.state.global.showPhoneForm = !$store.state.global.showPhoneForm">Luk</button>

            <!--
            <app-SoftPermissionPhone v-if="firm.userid"></app-SoftPermissionPhone>
            <app-PermissionPhone v-else></app-PermissionPhone>
            -->

            <app-PermissionPopPhone />

          </div>
      </transition>
    </div>

    <div v-if="survey[$route.params.survey]" class="card">
      <div class="callus" :class="{notLast:  hasNext}">
        <div class="callus-col-2">
          <div class="callus-col">
            <div v-html="compiledMarkdown(survey[$route.params.survey].call.content)">

            </div>
            <button class="btn-dark" @click="$store.state.global.showPhoneForm = !$store.state.global.showPhoneForm">{{survey[$route.params.survey].call.buttontext}}</button>
          </div>
          <div class="callus-col">
            <img class="callus-img" :src="survey[$route.params.survey].call.img" alt="">
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import PermissionPopPhone from '../PermissionPopPhone.vue';
import SoftPermissionPhone from '../softPermissionPhone.vue';
import Marked from 'marked';
import {mapGetters} from 'vuex';
export default {
  name: 'CallUs',
  props: {
    hasNext: {
      type: Boolean
    },
    doPop: {
      type: Boolean
    }
  },
  components: {
    appPermissionPopPhone: PermissionPopPhone,
    appSoftPermissionPhone: SoftPermissionPhone
  },
  data () {
    return {

    }
  },
  computed: {
      ...mapGetters([
        'survey',
        'firm',
        'answersCount',
        'globalC',
        'showPhoneForm'
      ])
  },
  mounted () {
    let self = this
    if (this.doPop /*&& this.firm.noform*/){
      setTimeout( function() {
        self.$store.state.global.showPhoneForm = true
      }, this.survey[this.$route.params.survey].call.poptime * 1000)
    }

  },
  methods:{
    compiledMarkdown(text) {
      text = text.replace("[count]", this.answersCount);
      return Marked(text, { sanitize: true })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/modular/call-us.vue